import { Check, X } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { Button } from '@/_components';
import { booleanFormToUpdateConverter } from '@/_schemas/generic/boolean-enum';

export function CommissionStatusButtonInput({
  isPending,
  onPartialUpdate,
}: {
  isPending: boolean;
  onPartialUpdate: (value: Record<string, boolean>, msg: string) => void;
}) {
  const form = useFormContext();
  const [status] = form.watch(['enable_commission']);

  const handleStatusCtrl = () => {
    const newOption = !status;
    form.setValue('enable_commission', newOption);
    onPartialUpdate({ enable_commission: booleanFormToUpdateConverter(newOption) }, 'Commission status updated');
  };

  return (
    <Button
      as="link"
      className="justify-start"
      disabled={isPending}
      size="xs"
      onClick={handleStatusCtrl}
      icon={status ? Check : X}
      iconClassName={status ? 'text-success' : 'text-error'}
      aria-label={status ? 'Enable Status' : 'Disable Status'}
    >
      {status ? 'Commission Active' : 'Commission Inactive'}
    </Button>
  );
}
